import { render, staticRenderFns } from "./MenuVertical.vue?vue&type=template&id=2ee8e33c"
import script from "./MenuVertical.vue?vue&type=script&lang=js"
export * from "./MenuVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports